module.exports = __webpack_public_path__ + "static/media/brycen2.dcba6a7f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brycen2.gif
// module id = 147
// module chunks = 0